import styled from 'styled-components';

export const StyledBrandFilterModal = styled.div``;
